class AttachmentUploadError extends Error {
    code: string;
    constructor(code: string, message: string) {
        super(message);
        this.name = 'AttachmentUploadError';
        this.code = code;
    }
}

export default AttachmentUploadError;

export const FILE_NOT_ACCEPTED = 'file_not_accepted';
export const FILE_TYPE_NOT_ALLOWED = 'file_type_not_allowed';
export const FILE_SIZE_EXCEEDED = 'file_size_exceeded';
export const ERROR_GENERIC = 'error_generic';
